








import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";
import { roles } from "@/constants/user";
import appService from "@/services/appService";
import BlurredTenant from '@/components/BlurredTenant.vue';

const assignableRoleMap = (roleKeys?: string[]) => {
  const userInfo = userManager.getUserInfo();
  const activeTenant = appService.getActiveTenant();
  if (!roleKeys) {
    roleKeys = [];
    if (userInfo) {
      switch (userInfo.role) {
        case "systemAdmin":
        case "admin":
          if (activeTenant) {
            roleKeys.push("cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
          } else {
            roleKeys.push("systemAdmin", "cpoGroup");
          }
          break;
        case "cpoAdmin":
          roleKeys.push("cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
          break;
      }
    }
  }
  const roleMap = {};
  for (const k of roleKeys) {
    roleMap[k] = roles[k];
  }
  return roleMap;
};

const filterableRoleMap = () => {
  const userInfo = userManager.getUserInfo();
  const activeTenant = appService.getActiveTenant();
  const roleKeys = [];
  if (userInfo) {
    switch (userInfo.role) {
      case "systemAdmin":
        roleKeys.push("systemAdmin", "cpoGroup", "cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
        break;
      case "admin":
          roleKeys.push("admin", "cpoGroup", "cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
          break;
      case "scAdmin":
        if (activeTenant) {
          roleKeys.push("scAdmin", "cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
        } else {
          roleKeys.push("cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
        }
        break;
      case "cpoAdmin":
        roleKeys.push("cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor");
        break;
    }
  }
  const roleMap = {};
  for (const k of roleKeys) {
    roleMap[k] = roles[k];
  }
  return roleMap;
};

export default Vue.extend({
  components: { BlurredTenant },
  methods: {
    async sendEmailActive(user) {
      try {
        // Show loading state
        this.$store.commit('setLoading', true);

        // Call API to send email active
        await coreApiClient.call(
          "users",
          "resendActivationEmail",
          {
            id: user._id,
          }
        );

        // Show success message
        this.$store.commit('showSnackbar', {
          text: `Email active sent successfully to ${user.email}`,
          color: 'success'
        });

        // Refresh the table data
        this.$refs.dataTable?.refresh();

      } catch (error) {
        console.error('Error sending email active:', error);

        // Show error message
        this.$store.commit('showSnackbar', {
          text: `Failed to send email active: ${(error as any)?.message || 'Unknown error'}`,
          color: 'error'
        });
      } finally {
        // Hide loading state
        this.$store.commit('setLoading', false);
      }
    },
  },
  data() {
    const that = this;
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "username",
          "sort-desc": false,
        },
        content: {
          name: "Users",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "tenants",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              orderBy: "name",
                              orderType: "asc",
                              filters: [
                                {
                                  key: "_id",
                                  operator: "equal_to",
                                  value,
                                },
                              ],
                            }),
                          }
                        );
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              name: {
                attrs: {
                  label: "Full Name",
                },
                rules: {
                  match: {},
                },
              },
              username: {
                attrs: {
                  label: "Username",
                },
                rules: {
                  match: {},
                },
              },
              email: {
                attrs: {
                  label: "Business Email",
                },
                rules: {
                  match: {},
                },
              },
              phone: {
                attrs: {
                  label: "Business Phone",
                },
                rules: {
                  match: {},
                },
              },
              role: {
                type: "select",
                attrs: {
                  label: "Role",
                  items: makeSelectOptions(filterableRoleMap()),
                },
                rules: {
                  equal_to: {},
                },
              },
              cpoGroupId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Partner",
                  "item-value": "_id",
                  "item-text": "name",
                  clearable: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("cpoGroups", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              status: {
                type: "select",
                attrs: {
                  label: "Status",
                  items: [
                    { text: "Active", value: true },
                    { text: "Inactive", value: false },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
              disabled: {
                type: "select",
                attrs: {
                  label: "Disabled",
                  items: [
                    { text: "Disabled", value: true },
                    { text: "Enable", value: false },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
              notifiable: {
                type: "select",
                attrs: {
                  label: "Notifiable",
                  items: [
                    { text: "Disabled", value: false },
                    { text: "Enable", value: true },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },

            },
          },
          displayFields: {
            username: {
              text: "Username",
              sortable: true,
            },
            email: {
              text: "Business Email",
              sortable: true,
            },
            name: {
              text: "Full Name",
              sortable: true,
            },
            phone: {
              text: "Business Phone",
              sortable: true,
            },
            role: {
              text: "Role",
              sortable: true,
              options: {
                label(value) {
                  return roles[value];
                },
              },
            },
            status: {
              text: "Status",
              options: {
                label(value) {
                  return (value && "Active") || "InActive";
                },
                attrs(value) {
                  return {
                    color: value ? "green" : "red",
                  };
                },
              },
            },
            disabled: {
              text: "Disabled",
              options: {
                label(value) {
                  return (value && "Disabled") || "Enable";
                },
                attrs(value) {
                  return {
                    color: value ? "red" : "green",
                  };
                },
              },
            },
            point: userManager.checkRole(["systemAdmin", "admin"]) && {
              text: "Amount",
              sortable: true,
              options: {
                preTransform(value) {
                  if (!value) { return 0 }
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            promotionPoint: userManager.checkRole(["systemAdmin", "admin"]) && {
              text: "Promotion",
              sortable: true,
              options: {
                subProp: "promotionPoint.current",
                preTransform(value) {
                  if (!value) { return 0 }
                  const val = (value / 1).toFixed(0);
                  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
              },
            },
            notifiable: {
              text: "Notifiable",
              options: {
                label(value) {
                  return (!value && "Disabled") || "Enable";
                },
                attrs(value) {
                  return {
                    color: !value ? "red" : "green",
                  };
                },
              },
            },

            createdTime: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            updatedTime: {
              text: "Updated Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            tenant: userManager.checkRole(["systemAdmin", "admin"]) && {
              text: "Organization",
              options: {
                subProp: "tenant.name",
                label: true,
                sortBy: "tenantId",
              },
            },
            action: {
              text: "Actions",
            },
          },
          topActionButtons: {
            export: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                text: "Export all",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  coreApiClient.download("users", `@/export`, dataTable.getFindAllOptions());
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && !userManager.checkRole(["cpoGroup"], true) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "email",
                    },
                  },
                },
              },
              sendEmailActive: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && !userManager.checkRole(["cpoGroup"], true) && {
                content: {
                  icon: "mdi-email-alert",
                  color: "primary",
                  small: true,
                },
                ext: {
                  condition(_, item) {
                    console.log(item && item.status === false);

                    return item && item.status === false;
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Send email active",
                    },
                  },
                },
                on: {
                  xClick({ self }) {
                    const { item, dataTable } = self.context();
                    if (that && that.sendEmailActive) {
                      that.sendEmailActive(item);

                      dataTable.info.value = `Email active sent successfully to ${item.email}`;
                    }
                  },
                },
              },
              viewUsageDashboard: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                content: {
                  icon: "mdi-view-dashboard",
                  color: "info",
                  small: true,
                },
                target: {
                  tooltip: {
                    content: {
                      text: "View Usage Dashboard",
                    },
                  },
                },
                on: {
                  xClick({ self }) {
                    const { item } = self.context();
                    self.$router.push(`/app/charging_memberships_dashboard?userId=${item._id}`);
                  },
                },
              },
              viewUsageHistory: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                content: {
                  icon: "mdi-history",
                  color: "success",
                  small: true,
                },
                target: {
                  tooltip: {
                    content: {
                      text: "View Usage History",
                    },
                  },
                },
                on: {
                  xClick({ self }) {
                    const { item } = self.context();
                    self.$router.push(`/app/charging_memberships_usage_history?userId=${item._id}`);
                  },
                },
              },
              delete: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && !userManager.checkRole(["cpoGroup"], true) && {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const payload = options.payload ? JSON.parse(options.payload) : {};
              const filters = payload.filters || [];
              if (!userManager.checkRole(["systemAdmin"])) {
                filters.push({
                    key: "role",
                    operator: "not_equal_to",
                    value: "systemAdmin",
                  });
              }
              payload.filters = filters;
              options.payload = JSON.stringify(payload);
              const { items, count } = await coreApiClient.call(
                "users",
                "findAll",
                options
              );
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call(
                "users",
                "create",
                undefined,
                item
              );
            },
            async update(item) {
              return await coreApiClient.call(
                "users",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("users", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Full Name",
                  required: true,
                },
              },
              username: {
                attrs: {
                  label: "Username",
                  required: true,
                },
              },
              email: {
                type: "email",
                attrs: {
                  label: "Business Email",
                  required: true,
                },
              },
              tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: false,
                  "item-value": "_id",
                  "item-text": (item) => `${item.name}`,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("tenants", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              phone: {
                type: "phone",
                attrs: {
                  label: "Business Phone",
                },
              },
              role: {
                type: "select",
                attrs: {
                  label: "Role",
                  required: true,
                },
                ext: {
                  makeAttrs(attrs: any = {}, self) {
                    const form = self.context();
                    if (userManager.checkRole(["systemAdmin"])) {
                      const activeTenant = appService.getActiveTenant();
                      if (!activeTenant && form.data?.value?.tenantId) {
                        attrs.items = makeSelectOptions(
                          assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor"])
                        );
                      } else {
                        attrs.items = makeSelectOptions(
                          assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "systemAdmin", "admin", "cpoGroup", "socketMonitor"])
                        );
                      }
                    }
                    if (userManager.checkRole(["admin"])) {
                      const activeTenant = appService.getActiveTenant();
                      if (!activeTenant && form.data?.value?.tenantId) {
                        attrs.items = makeSelectOptions(
                          assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor"])
                        );
                      } else {
                        attrs.items = makeSelectOptions(
                          assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "admin", "cpoGroup", "socketMonitor"])
                        );
                      }
                    }
                    if (!attrs.items) {
                      attrs.items = makeSelectOptions(assignableRoleMap());
                    }
                    return attrs;
                  },
                },
              },
              status: {
                type: "boolean",
                attrs: {
                  label: "Active",
                },
                ext: {
                  defaultValue: true,
                },
              },
              disabled: {
                type: "boolean",
                attrs: {
                  label: "Disabled",
                },
                ext: {
                  defaultValue: false,
                },
              },
              notifiable: {
                type: "boolean",
                attrs: {
                  label: "Notifiable",
                },
                ext: {
                  defaultValue: false,
                },
              },
              cpoGroupId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Partner",
                  "item-value": "_id",
                  "item-text": "name",
                  clearable: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("cpoGroups", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                ext: {
                  makeAttrs(attrs: any = {}, self) {
                    const form = self.context();
                    // Only show CPO Group if role is cpoGroup
                    const role = form.data?.value?.role;
                    if (role === "cpoGroup") {
                      attrs.required = true;
                    }
                    return attrs;
                  },
                },
              },

            },
            insertForm:
              userManager.checkRole(["systemAdmin", "admin"]) ? {
                content: {
                  fieldNames: [
                    "name",
                    "username",
                    "password",
                    "email",
                    "phone",
                    "tenantId",
                    "role",
                    "status",
                    "notifiable"
                  ],
                  fields: {
                    name: {},
                    username: {},
                    password: {
                      type: "password",
                      attrs: {
                        label: "Password",
                        required: true,
                      },
                    },
                  },
                },
              } : (userManager.checkRole(["cpoAdmin"]) && {
                content: {
                  fieldNames: [
                    "name",
                    "username",
                    "password",
                    "email",
                    "phone",
                    "role",
                    "status",
                    "notifiable"
                  ],
                  fields: {
                    name: {},
                    username: {},
                    password: {
                      type: "password",
                      attrs: {
                        label: "Password",
                        required: true,
                      },
                    },
                  },
                },
              }),
            editForm: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"]) && {
              content: {
                                  fieldNames: [
                    "name",
                    "username",
                    "password",
                    "email",
                    "phone",
                    "role",
                    "cpoGroupId",
                    "status",
                    "disabled",
                    "notifiable"
                  ],
                fields: {
                  name: {},
                  username: {},
                  password: {
                    type: "password",
                    attrs: {
                      label: "Password",
                    },
                  },
                  role: {
                    type: "select",
                    attrs: {
                      label: "Role",
                      required: true,
                    },
                    ext: {
                      makeAttrs(attrs: any = {}, self) {
                        const form = self.context();
                        const userTenantId = form.data?.value?.tenantId;

                        if (userManager.checkRole(["systemAdmin"])) {
                          // If user being edited has a tenant, show CPO roles
                          if (userTenantId) {
                            attrs.items = makeSelectOptions(
                              assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor"])
                            );
                          } else {
                            // If no tenant, show system-level roles
                            attrs.items = makeSelectOptions(
                              assignableRoleMap(["systemAdmin", "admin", "cpoGroup"])
                            );
                          }
                        } else if (userManager.checkRole(["admin"])) {
                          // If user being edited has a tenant, show CPO roles
                          if (userTenantId) {
                            attrs.items = makeSelectOptions(
                              assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor"])
                            );
                          } else {
                            // If no tenant, show system-level roles
                            attrs.items = makeSelectOptions(
                              assignableRoleMap(["admin", "cpoGroup"])
                            );
                          }
                        } else if (userManager.checkRole(["cpoAdmin"])) {
                          attrs.items = makeSelectOptions(
                            assignableRoleMap(["cpoAdmin", "cpoMonitor", "retailer", "user", "socketMonitor"])
                          );
                        }

                        if (!attrs.items) {
                          attrs.items = makeSelectOptions(assignableRoleMap());
                        }
                        return attrs;
                      },
                    },
                  },
                },
              },
            },
            delete: {
              confirmDisplayField: "email",
            },
          },
        },
      },
    };
  },
});
